// extracted by mini-css-extract-plugin
export default {"editableText":"SQ0tzqWUKH7bybTBtGki","empty":"s8P5U_JBsIVbnq9kHFvc"};